import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Button from "../button/index.js";
import Card from "../card/index.js";
import Icons from "../../icons/index.js";

import styles from "./styles.module.scss";

const Drawer = ({
  children,
  closeDrawer = false,
  customButton,
  drawerHeading,
  drawerPosition = "right",
  openDrawerButtonProps = {},
  openDrawerCardProps = {}
}) => {
  const [showDrawer, setShowDrawer] = useState(false);

  useEffect(() => {
    setShowDrawer(closeDrawer);
  }, [closeDrawer]);

  return (
    <>
      {showDrawer && (
        <div className={styles.drawer}>
          <button
            className={styles.drawerOverlay}
            onClick={() => {
              setShowDrawer(false);
              if (openDrawerButtonProps.onClick) {
                openDrawerButtonProps.onClick();
              }
            }}
          />
          <div
            className={styles.drawerCardWrapper}
            data-drawer-position={drawerPosition}
          >
            <Card
              className={styles.card}
              corners="sharp"
              headerProps={{
                control: (
                  <Button
                    corners="rounded"
                    icon={
                      drawerPosition === "right" ? (
                        <Icons.ArrowRightIcon />
                      ) : (
                        <Icons.ArrowLeftIcon />
                      )
                    }
                    onClick={() => {
                      setShowDrawer(false);
                      if (openDrawerButtonProps.onClick) {
                        openDrawerButtonProps.onClick();
                      }
                    }}
                  />
                ),
                direction: drawerPosition === "right" ? "ltr" : "rtl",
                heading: drawerHeading
              }}
              profiling="borderless"
              {...openDrawerCardProps}
            >
              {children}
            </Card>
          </div>
        </div>
      )}
      {customButton ? (
        customButton({ onClick: () => setShowDrawer(true) })
      ) : (
        <Button
          {...openDrawerButtonProps}
          onClick={() => {
            setShowDrawer(true);
            if (openDrawerButtonProps.onClick) {
              openDrawerButtonProps.onClick();
            }
          }}
        />
      )}
    </>
  );
};

Drawer.propTypes = {
  children: PropTypes.node.isRequired,
  closeDrawer: PropTypes.bool,
  drawerHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  drawerPosition: PropTypes.oneOf(["left", "right"]),
  openDrawerButtonProps: PropTypes.object,
  openDrawerCardProps: PropTypes.object
};

export default Drawer;
